// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import { QueryClient, QueryClientProvider } from 'react-query';
// // import { ReactQueryDevtools } from 'react-query/devtools';
// import { Toaster } from 'react-hot-toast';
// import './index.css';
// import App from './App';
// import { AuthProvider } from './context/AuthContext';
// import { NotificationProvider } from './context/NotificationContext';
// import { NotificationCenterProvider } from './context/NotificationCenterContext';
// import 'sweetalert2/dist/sweetalert2.min.css';

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       refetchOnWindowFocus: false,
//       retry: 3,
//       staleTime: 5 * 60 * 1000,
//     },
//   },
// });

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <QueryClientProvider client={queryClient}>
//         <NotificationCenterProvider>
//           <AuthProvider>
//             <NotificationProvider>
//               <App />
//               <Toaster />
//             </NotificationProvider>
//           </AuthProvider>
//         </NotificationCenterProvider>
//         <ReactQueryDevtools initialIsOpen={false} />
//       </QueryClientProvider>
//     </BrowserRouter>
//   </React.StrictMode>
// );

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { NotificationCenterProvider } from './context/NotificationCenterContext';
import 'sweetalert2/dist/sweetalert2.min.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: 5 * 60 * 1000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <NotificationCenterProvider>
          <AuthProvider>
            <NotificationProvider>
              <App />
              <Toaster />
            </NotificationProvider>
          </AuthProvider>
        </NotificationCenterProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);